// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"d12bca0c","224":"96a875b9","413":"417d261f","591":"84270f18","682":"0f2f2323","818":"374502e6","825":"f07754bd","962":"1e22591c"}[chunkId] + ".chunk.js";
};